import { Space } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Form } from 'components/atoms/form';
import { Modal } from 'components/atoms/modal';
import { Radio } from 'components/atoms/radio';
import { BodyLong01, Caption01 } from 'components/styles';
import { useTranslate } from 'hooks/use-translation';

const StyledForm = styled(Form)`
  width: 80%;
`;

const RadioContent = styled(Space).attrs({
  direction: 'vertical',
  size: 0,
})`
  p {
    ${BodyLong01};
    color: var(--gray-100);
    margin-bottom: 0;
  }
  small {
    ${Caption01};
    white-space: normal;
    color: var(--gray-80);
  }
`;

const Spacer = styled.div`
  margin-bottom: var(--spacing-05);
`;

export const BackDateCustomRatesModal = ({ visible, onOk, onCancel }) => {
  const translate = useTranslate();
  const [enableBackDates, setEnabledBackDates] = useState(false);

  return (
    <Modal
      title={translate(
        'project.settings.budget.rate.edit.apply.bill.rate.effect',
      )}
      visible={visible}
      okText={translate('save')}
      cancelText={translate('cancel')}
      onOk={() => onOk(enableBackDates)}
      onCancel={onCancel}
    >
      <StyledForm layout="vertical">
        <Form.Item>
          <Radio.Group
            value={enableBackDates}
            onChange={(e) => setEnabledBackDates(e.target.value)}
          >
            <Radio value={false}>
              <RadioContent>
                <p>
                  {translate(
                    'project.settings.budget.rate.edit.apply.bill.rate.going.forward',
                  )}
                </p>

                <small>
                  {translate(
                    'project.settings.budget.rate.edit.apply.bill.rate.going.forward.help',
                  )}
                </small>
              </RadioContent>
            </Radio>

            <Spacer />
            <Radio value>
              <RadioContent>
                <p>
                  {translate(
                    'project.settings.budget.rate.edit.apply.bill.rate.project.start',
                  )}
                </p>

                <small>
                  {translate(
                    'project.settings.budget.rate.edit.apply.bill.rate.project.start.help',
                  )}
                </small>
              </RadioContent>
            </Radio>
          </Radio.Group>
        </Form.Item>
      </StyledForm>
    </Modal>
  );
};
